import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
export default function useSafeAreaInsetsReady(shouldWait) {
  const $ = _c(5);
  let t0;
  if ($[0] !== shouldWait) {
    t0 = shouldWait ? Symbol("safe-area-insets") : null;
    $[0] = shouldWait;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const waitCycle = t0;
  const [readyCycle, setReadyCycle] = useState(null);
  let t1;
  let t2;
  if ($[2] !== waitCycle) {
    t1 = () => {
      if (!waitCycle) {
        return;
      }
      const probe = document.createElement("div");
      probe.style.paddingBottom = "env(safe-area-inset-bottom)";
      document.body.appendChild(probe);
      let rafId = null;
      let lastValue = null;
      let stableCount = 0;
      let isDone = false;
      let timeoutId = null;
      const finish = () => {
        if (isDone) {
          return;
        }
        isDone = true;
        setReadyCycle(waitCycle);
        if (rafId) {
          cancelAnimationFrame(rafId);
        }
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (document.body.contains(probe)) {
          document.body.removeChild(probe);
        }
      };
      const tick = () => {
        const computed = window.getComputedStyle(probe).paddingBottom;
        const value = Number.parseFloat(computed);
        if (!Number.isNaN(value)) {
          if (value === lastValue) {
            stableCount = stableCount + 1;
            stableCount;
          } else {
            stableCount = 0;
            lastValue = value;
          }
          if (stableCount >= 3) {
            finish();
            return;
          }
        }
        rafId = requestAnimationFrame(tick);
      };
      rafId = requestAnimationFrame(tick);
      timeoutId = setTimeout(finish, 1500);
      return () => {
        clearTimeout(timeoutId);
        if (rafId) {
          cancelAnimationFrame(rafId);
        }
        if (document.body.contains(probe)) {
          document.body.removeChild(probe);
        }
      };
    };
    t2 = [waitCycle];
    $[2] = waitCycle;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return !waitCycle || readyCycle === waitCycle;
}